import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * LoadingSpinner Component
 * Standardized loading component for consistent loading states across the application
 * 
 * @param {Object} props
 * @param {string} props.message - Optional message to display below the spinner
 * @param {boolean} props.fullScreen - If true, displays as full screen overlay
 * @param {string} props.size - Size of the spinner ('small' | 'medium' | 'large')
 */
export default function LoadingSpinner({ message, fullScreen = false, size = 'large' }) {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 56,
  };

  const spinnerSize = sizeMap[size] || sizeMap.large;

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          zIndex: 9999,
        }}
      >
        <CircularProgress size={spinnerSize} />
        {message && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      <CircularProgress size={spinnerSize} />
      {message && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
}







